import { logger } from '@finance/shared';

export type ColorMode = 'light' | 'dark';

export const COLOR_MODE_ATTRIBUTE = 'data-hbui-color-mode';

export function parseColorMode(value: unknown): ColorMode {
    return value === 'dark' ? 'dark' : 'light';
}

export function getColorModeFromQuery(query: Record<string, unknown>): ColorMode {
    const queryMode = Array.isArray(query.color_mode) ? query.color_mode[0] : query.color_mode;
    if (typeof queryMode === 'string') {
        return parseColorMode(queryMode);
    }
    if (typeof query.callbackUrl === 'string') {
        try {
            const url = new URL(query.callbackUrl, 'http://localhost');
            return parseColorMode(url.searchParams.get('color_mode'));
        } catch {
            logger.warn({ callbackUrl: query.callbackUrl }, 'Failed to parse callbackUrl for color_mode');
            return 'light';
        }
    }
    return 'light';
}

export function setColorModeParam(callbackUrl: string, colorMode: unknown): string {
    if (!colorMode) {
        return callbackUrl;
    }
    const hashIndex = callbackUrl.indexOf('#');
    const hash = hashIndex === -1 ? '' : callbackUrl.slice(hashIndex);
    const withoutHash = hashIndex === -1 ? callbackUrl : callbackUrl.slice(0, hashIndex);
    const queryIndex = withoutHash.indexOf('?');
    const path = queryIndex === -1 ? withoutHash : withoutHash.slice(0, queryIndex);
    const params = new URLSearchParams(queryIndex === -1 ? '' : withoutHash.slice(queryIndex + 1));
    params.set('color_mode', parseColorMode(colorMode));
    return `${path}?${params.toString()}${hash}`;
}
